import {
    GetPartitionByIdResponse,
    GetPartitionCallOffCodesByIdResponse,
    QueryPartitionsOptions,
    QueryPartitionsResponse,
    getPartitionById,
    getPartitionCallOffCodeById,
    guid,
    queryPartitions,
} from "./partition-service";
import { useEffect, useState } from "react";

export type ApiCallState<TResponse> = {
    loading: boolean;
    error: Error | null;
    data: TResponse | null;
    refresh?: () => void | undefined;
};

export function useGetPartitionById(id: guid, revalidateCache: boolean = false) {
    const [state, setState] = useState<ApiCallState<GetPartitionByIdResponse>>({
        data: null as any,
        error: null as any,
        loading: false,
    });
    const [refreshIndex, setRefreshIndex] = useState(0);

    useEffect(() => {
        setState({ data: null as any, error: null as any, loading: true });
        (async () => {
            try {
                const data = await getPartitionById(id, revalidateCache);
                setState({ data, error: null, loading: false });
            } catch (error: any) {
                setState({ data: null, error, loading: false });
            }
        })();
    }, [id, refreshIndex]);

    return {
        ...state,
        refresh: () => setRefreshIndex(refreshIndex + 1),
    };
}

export function useGetPartitionCallOffCodeById(id: guid) {
    const [state, setState] = useState<ApiCallState<GetPartitionCallOffCodesByIdResponse>>({
        data: null as any,
        error: null as any,
        loading: false,
    });
    const [refreshIndex, setRefreshIndex] = useState(0);

    useEffect(() => {
        setState({ data: null as any, error: null as any, loading: true });
        (async () => {
            try {
                const data = await getPartitionCallOffCodeById(id);
                const callOfCodeResponse: GetPartitionCallOffCodesByIdResponse = {
                    callOffCodes:data
                }
                setState({ data: callOfCodeResponse, error: null, loading: false });
            } catch (error: any) {
                setState({ data: null, error, loading: false });
            }
        })();
    }, [id, refreshIndex]);

    return {
        ...state,
        refresh: () => setRefreshIndex(refreshIndex + 1),
    };
}

export function useQueryPartitions(options: QueryPartitionsOptions) {
    const [state, setState] = useState<ApiCallState<QueryPartitionsResponse>>({
        data: null as any,
        error: null as any,
        loading: false,
    });
    const [refreshIndex, setRefreshIndex] = useState(0);

    useEffect(() => {
        setState({ data: null as any, error: null as any, loading: true });
        (async () => {
            try {
                const data = await queryPartitions(options);

                setState({ data, error: null, loading: false });
            } catch (error: any) {
                setState({ data: null, error, loading: false });
            }
        })();
    }, [refreshIndex, options]);

    return {
        ...state,
        refresh: () => setRefreshIndex(refreshIndex + 1),
    };
}
